import { createCheckOutbound, createFoldOutbound, createSetBuyInOutbound, createSitOutbound, createSitWithBuyInOutbound } from '../../api/outbound/pokerOutbounds';
import { isCard } from '../../types/cardTypes';
import { isDefaultShowdown } from '../../types/pokerTypes';
import { ALL_POKER_VARIANT_PROPERTIES } from '../../types/pokerVariantTypes';
import { maybeOverrideAvatar } from '../../utils/avatarUtils';
import { MINIMUM_PLAYER_ANIMATION_DURATION_MS } from '../../utils/playerAnimationUtils';
import { validateSupportedPokerVariantIdOrShowError } from '../../utils/pokerVariantUtils';
import { maybePlayAllInSound, maybePlayBetOrCallSound, maybePlayCheckSound, maybePlayFlopSound, maybePlayFoldSound, maybePlayLoseSound, maybePlayRaiseSound, maybePlayRevealSound, maybePlayShowdownSound, maybePlayShuffleSound, maybePlayWinSound, maybePlayYourTurnSound } from '../../utils/soundUtils';
import { isTestEnvironment } from '../../utils/utils';
import { addPlayerAnimation, clearPlayerAnimations } from './animationsActions';
import { removeAllBombSplats, thunkRemoveAllPlayerIdBombSplats } from './bombsActions';
import { addPlayerEnterChatItem, addPlayerLeaveChatItem } from './chatActions';
import { setIsSelfSittingForGameDimensions, updateGameDimensionsFromGameSettings } from './gameDimensionsActions';
import { addCommunityCardsHistoryEntry, addHandEndHistoryEntry, addHoleCardsHistoryEntry, addHtmlHistoryEntry, addRevealedCardsHistoryEntry, addTextHistoryEntry } from './historyActions';
import { addMessageBox } from './messageBoxesActions';
import { setNumMttTables } from './mttActions';
import { setSelfAvatar } from './selfAvatarActions';
import { setPlayerServerSettingsFromInbound } from './selfDataActions';
import { disableMySideBetControls, setIsSelectingSideBetTarget, thunkClearSideBetsState } from './sideBetsActions';
import { thunkSetThemeFromInbound } from './themeActions';
import { thunkEndTransitionAnimation } from './transitionAnimationActions';
export const CLEAR_POKER_SCENE = 'CLEAR_POKER_SCENE';
export const SIT_PLAYER_FROM_INBOUND = 'SIT_PLAYER_FROM_INBOUND';
export const UNSET_PENDING_SIT_PLAYER_ANIMATION = 'UNSET_PENDING_SIT_PLAYER_ANIMATION';
export const STAND_UP_FROM_INBOUND = 'STAND_UP_FROM_INBOUND';
export const STAND_UP_DELAYED_FROM_INBOUND = 'STAND_UP_DELAYED_FROM_INBOUND';
export const ENTER_POKER_PLAYER_FROM_INBOUND = 'ENTER_POKER_PLAYER_FROM_INBOUND';
export const LEAVE_POKER_PLAYER_FROM_INBOUND = 'LEAVE_POKER_PLAYER_FROM_INBOUND';
export const START_HAND_FROM_INBOUND = 'START_HAND_FROM_INBOUND';
export const INIT_POKER_ROOM_FROM_INBOUND = 'INIT_GAME_FROM_INBOUND';
export const START_SEAT_TIMERS_FROM_INBOUND = 'START_SEAT_TIMERS_FROM_INBOUND';
export const BET_FROM_INBOUND = 'BET_FROM_INBOUND';
export const HAND_WIN_FROM_INBOUND = 'HAND_WIN_FROM_INBOUND';
export const SET_MY_PLAYER_ID = 'SET_MY_PLAYER_ID';
export const SHOW_ALL_IN_HANDS_FROM_INBOUND = 'SHOW_ALL_IN_HANDS_FROM_INBOUND';
export const SHOW_ALL_IN_COMMUNITY_CARDS_FROM_INBOUND = 'SHOW_ALL_IN_COMMUNITY_CARDS_FROM_INBOUND';
export const SET_BET_SLIDER_AMOUNT = 'SET_BET_SLIDER_AMOUNT';
export const SET_BET_SLIDER_X = 'SET_BET_SLIDER_X';
export const WAIT_PHASE_FROM_INBOUND = 'WAIT_PHASE_FROM_INBOUND';
export const START_SHOWDOWN = 'START_SHOWDOWN';
export const SET_BLIND_TIMER_FROM_INBOUND = 'SET_BLIND_TIMER_FROM_INBOUND';
export const UPDATE_PLAYERS_FROM_INBOUND = 'UPDATE_PLAYERS_FROM_INBOUND';
export const ADD_SEATED_PLAYER_CHIPS = 'ADD_SEATED_PLAYER_CHIPS';
export const SET_POKER_PLAYER_BANK = 'SET_POKER_PLAYER_BANK_FROM_INBOUND';
export const SET_SIT_OUT_SELF_STATUS_FROM_INBOUND = 'SET_SIT_OUT_SELF_STATUS_FROM_INBOUND';
export const SET_SIT_OUT_STATUS_FROM_INBOUND = 'SET_SIT_OUT_STATUS_FROM_INBOUND';
export const SET_POKER_ROOM_INFO_FROM_INBOUND = 'SET_POKER_ROOM_INFO_FROM_INBOUND';
export const HAND_RECONNECT_FROM_INBOUND = 'HAND_RECONNECT_FROM_INBOUND';
export const BECOME_OWNER = 'BECOME_OWNER';
export const UPDATE_HAND_RANK_FROM_INBOUND = 'UPDATE_HAND_RANK_FROM_INBOUND';
export const SET_STATUS_MESSAGE = 'SET_STATUS_MESSAGE';
export const UPDATE_POKER_ROOM_FOR_CLOSED_MTT = 'UPDATE_POKER_ROOM_FOR_CLOSED_MTT';
export const UPDATE_JACKS_FROM_INBOUND = 'UPDATE_JACKS_FROM_INBOUND';
export const SET_DISCARD_PHASE_FROM_INBOUND = 'SET_DISCARD_PHASE_FROM_INBOUND';
export const UPDATE_POT_AMOUNTS_FROM_INBOUND = 'UPDATE_POT_AMOUNTS_FROM_INBOUND';
export const SET_SEATED_PLAYER_AVATAR_FROM_INBOUND = 'SET_SEATED_PLAYER_AVATAR_FROM_INBOUND';
export const UPDATE_PLAYERS_MEDALS_AND_STYLE_FROM_INBOUND = 'UPDATE_PLAYERS_MEDALS_AND_STYLE_FROM_INBOUND';
export const SET_IS_AUTO_CHECKING = 'SET_IS_AUTO_CHECKING';
export const SET_IS_AUTO_FOLDING_ANY = 'SET_IS_AUTO_FOLDING_ANY';
export const SET_HAND_REVEALING_FROM_INBOUND = 'SET_HAND_REVEALING_FROM_INBOUND';
export const SET_REQUESTED_BUY_IN = 'SET_REQUESTED_BUY_IN';
export const SET_DISCARD_CARD_INDEX = 'SET_DISCARD_CARD_INDEX';
export const SET_HOLE_CARDS_AFTER_DISCARD_FROM_INBOUND = 'SET_HOLE_CARDS_AFTER_DISCARD_FROM_INBOUND';
export const SET_DISCARD_PHASE_DONE_FROM_INBOUND = 'SET_DISCARD_PHASE_DONE_FROM_INBOUND';
export const SET_PENDING_DISCARD_INDEX = 'SET_PENDING_DISCARD_INDEX';
export const SET_PLAYER_HAS_DISCARDED_FROM_INBOUND = 'SET_PLAYER_HAS_DISCARDED_FROM_INBOUND';
export const UPDATE_LAST_CHIP_STACK_FROM_INBOUND = 'UPDATE_LAST_CHIP_STACK_FROM_INBOUND';
export const SHOW_BLANK_CHAT_BUBBLE_FROM_INBOUND = 'SHOW_BLANK_CHAT_BUBBLE_FROM_INBOUND';
export const HIDE_CHAT_BUBBLE = 'HIDE_CHAT_BUBBLE';
export const HIDE_DEALING_MESSAGE = 'HIDE_DEALING_MESSAGE';
export const RENAME_POKER_ROOM = 'RENAME_POKER_ROOM';
export const SHOW_POKER_ROOM_PRIZE_WIN_FROM_INBOUND = 'SHOW_POKER_ROOM_PRIZE_WIN_FROM_INBOUND';
export const HIDE_POKER_ROOM_PRIZE_WIN = 'HIDE_POKER_ROOM_PRIZE_WIN';
export const UPDATE_CHIP_STACKS_FROM_INBOUND = 'UPDATE_CHIP_STACKS_FROM_INBOUND';
export const START_WIN_CHIPS_ANIMATION = 'START_WIN_CHIPS_ANIMATION';
export const CLEAR_WIN_CHIPS_ANIMATION = 'CLEAR_WIN_CHIPS_ANIMATION';
export const SET_SIDE_BET_PHASE_FROM_INBOUND = 'SET_SIDE_BET_PHASE_FROM_INBOUND';
export function clearPokerScene() {
    return { type: CLEAR_POKER_SCENE };
}
function sitPlayerFromInbound(sitInbound) {
    return {
        type: SIT_PLAYER_FROM_INBOUND,
        payload: sitInbound
    };
}
export function thunkSitPlayerFromInbound(inbound) {
    return function (dispatch, getState) {
        dispatch(sitPlayerFromInbound(inbound));
        if (inbound.playerId === getState().selfData.id) {
            dispatch(setIsSelfSittingForGameDimensions(true));
        }
    };
}
export function unsetPendingSitPlayerAnimation(seatIndex) {
    return {
        type: UNSET_PENDING_SIT_PLAYER_ANIMATION,
        payload: seatIndex
    };
}
function standUpFromInbound(inbound) {
    return {
        type: STAND_UP_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkStandUpFromInbound(inbound) {
    return function (dispatch, getState) {
        const seatedPlayer = Object.values(getState().poker.seatedPlayers).find((currSeatedPlayer) => currSeatedPlayer?.id === inbound.playerId);
        if (seatedPlayer) {
            dispatch(clearPlayerAnimations(seatedPlayer.seatIndex));
        }
        dispatch(thunkRemoveAllPlayerIdBombSplats(inbound.playerId));
        dispatch(standUpFromInbound(inbound));
        if (inbound.playerId === getState().selfData.id) {
            dispatch(setIsSelfSittingForGameDimensions(false));
        }
    };
}
export function standUpDelayedFromInbound(inbound) {
    return {
        type: STAND_UP_DELAYED_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkEnterPokerPlayerFromInbound(inbound) {
    return function (dispatch) {
        dispatch({
            type: ENTER_POKER_PLAYER_FROM_INBOUND,
            payload: inbound
        });
        dispatch(addPlayerEnterChatItem(inbound.enterMessage));
    };
}
export function thunkLeavePokerPlayerFromInbound(inbound) {
    return function (dispatch) {
        dispatch(thunkRemoveAllPlayerIdBombSplats(inbound.playerId));
        dispatch({
            type: LEAVE_POKER_PLAYER_FROM_INBOUND,
            payload: inbound
        });
        dispatch(addPlayerLeaveChatItem(inbound.message));
    };
}
function startHandFromInbound(inbound) {
    return {
        type: START_HAND_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkStartHandFromInbound = (inbound) => {
    return function (dispatch, getState) {
        function addToHistory(state) {
            if (state.history.handHistoryEntries.length) {
                // add a hand separator if this is not the first hand:
                dispatch(addHandEndHistoryEntry());
            }
            dispatch(addTextHistoryEntry(`Dealing ${ALL_POKER_VARIANT_PROPERTIES[inbound.pokerVariant].shortName}`, 'main'));
            dispatch(addHoleCardsHistoryEntry(inbound.holeCards));
        }
        const state = getState();
        maybePlayShuffleSound(state);
        dispatch(startHandFromInbound(inbound));
        dispatch(thunkClearSideBetsState());
        addToHistory(state);
    };
};
function initPokerRoomFromInbound(inbound) {
    return {
        type: INIT_POKER_ROOM_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkInitPokerRoomFromInbound = (inbound) => {
    return function (dispatch, getState) {
        function updateStageDimensions() {
            const state = getState();
            const myPlayerId = state.selfData.id;
            const isSelfSitting = !!inbound.inboundPokerPlayers.find((inboundPokerPlayer) => inboundPokerPlayer.id === myPlayerId && inboundPokerPlayer.seatIndex !== undefined);
            dispatch(setIsSelfSittingForGameDimensions(isSelfSitting));
            dispatch(updateGameDimensionsFromGameSettings({
                numAvailableSeats: inbound.seatIndexesAvailable.length,
                isAllInGame: inbound.isAllInGame
            }));
        }
        function maybeShowAggroBettingFilterMessageBox() {
            if (!inbound.isAggroBettingFilterEnabled) {
                return;
            }
            const params = new URLSearchParams(window.location.search);
            if (isTestEnvironment() && params.get('enableAggroBettingFilterAlert') !== 'true') {
                // running in a test environment, but is not explicitly showing the alert
                return;
            }
            dispatch(addMessageBox({
                type: 'confirm',
                title: 'Aggro Betting Filter is On',
                message: [
                    'Making repeated huge overbets may ban you from this room. This setting was enabled here to limit super-aggressive playing for folks who prefer a more strategic poker game.',
                    'You will be given a warning if your betting risks breaking the rule.',
                    "You can join or create a game that doesn't have this setting enabled if you prefer."
                ],
                isHtmlMessage: false,
                showCloseButton: true,
                buttons: [
                    {
                        label: 'Got it!',
                        actions: [],
                        closeAfterClick: true
                    }
                ]
            }));
        }
        dispatch(setPlayerServerSettingsFromInbound(inbound.inboundPlayerServerSettings));
        dispatch(initPokerRoomFromInbound(inbound));
        dispatch(setNumMttTables(inbound.numMttTables));
        dispatch(setSelfAvatar(maybeOverrideAvatar(getState().selfData.id, getState().selfData.username, inbound.avatar) || inbound.avatar));
        dispatch(thunkSetThemeFromInbound(inbound, getState().selfData.isPowerPlayer));
        maybeShowAggroBettingFilterMessageBox();
        updateStageDimensions();
        dispatch(thunkEndTransitionAnimation());
    };
};
export function startSeatTimersFromInbound(startSeatTimersInbound) {
    return {
        type: START_SEAT_TIMERS_FROM_INBOUND,
        payload: startSeatTimersInbound
    };
}
function betFromInbound(inbound) {
    return {
        type: BET_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkBetFromInbound = (inbound, socketSend) => {
    return function (dispatch, getState) {
        function playSounds() {
            const state = getState();
            if (inbound.isMyTurn) {
                maybePlayYourTurnSound(state);
            }
            if (inbound.newCommunityCards.length) {
                maybePlayFlopSound(state);
            }
            if (inbound.lastAction) {
                switch (inbound.lastAction.actionType) {
                    case 'check': {
                        maybePlayCheckSound(state);
                        break;
                    }
                    case 'call': {
                        maybePlayBetOrCallSound(state);
                        break;
                    }
                    case 'bet': {
                        maybePlayBetOrCallSound(state);
                        break;
                    }
                    case 'raise': {
                        maybePlayRaiseSound(state);
                        break;
                    }
                    case 'fold': {
                        maybePlayFoldSound(state);
                        break;
                    }
                    case 'all-in': {
                        maybePlayAllInSound(state);
                        break;
                    }
                }
            }
        }
        function maybeAutoBet() {
            const autoBetProperties = getState().poker.autoBetProperties;
            if (!autoBetProperties) {
                return;
            }
            const { myTurnProperties } = getState().poker;
            if (!myTurnProperties) {
                // not my turn
                return;
            }
            const { betSequenceNumber, canCheck, canFold } = myTurnProperties;
            if (autoBetProperties.isAutoChecking && canCheck) {
                socketSend(createCheckOutbound(betSequenceNumber));
                return;
            }
            if (autoBetProperties.isAutoFoldingAny) {
                if (canCheck) {
                    socketSend(createCheckOutbound(betSequenceNumber));
                    return;
                }
                else if (canFold) {
                    socketSend(createFoldOutbound(betSequenceNumber));
                    return;
                }
            }
        }
        function maybeShowBetActionPlayerAnimation() {
            const { lastAction } = inbound;
            if (lastAction && lastAction.actionType !== 'fold') {
                dispatch(addPlayerAnimation(lastAction.seatIndex, {
                    type: 'bet-action',
                    totalY: -15,
                    durationMs: Math.max(500, MINIMUM_PLAYER_ANIMATION_DURATION_MS)
                }));
            }
        }
        playSounds();
        dispatch(betFromInbound(inbound));
        if (inbound.newCommunityCards.length) {
            dispatch(addCommunityCardsHistoryEntry(inbound.newCommunityCards.map((communityCard) => communityCard.card), inbound.newBetRoundNumber));
        }
        maybeShowBetActionPlayerAnimation();
        maybeAutoBet();
    };
};
function setHandWinFromInbound(handWinInbound) {
    return {
        type: HAND_WIN_FROM_INBOUND,
        payload: handWinInbound
    };
}
function startShowdown(showdownIndex) {
    return {
        type: START_SHOWDOWN,
        payload: showdownIndex
    };
}
export const thunkStartShowdown = (showdownIndex) => {
    return function (dispatch, getState) {
        function playSounds() {
            const state = getState();
            const isWinning = state.poker.mySeatIndex !== undefined && !!state.poker.winningSeatIndexes?.includes(state.poker.mySeatIndex);
            if (isWinning) {
                maybePlayWinSound(state);
            }
            else {
                const isLosing = state.poker.mySeatIndex && !!state.poker.revealedHands[state.poker.mySeatIndex];
                if (isLosing) {
                    maybePlayLoseSound(state);
                }
                else {
                    maybePlayShowdownSound(state);
                }
            }
        }
        function addToHistory() {
            const state = getState();
            const currentShowdown = state.poker.currentShowdown;
            if (!currentShowdown) {
                return;
            }
            function getHeaderText(numPots, showdown) {
                const isDefault = isDefaultShowdown(showdown);
                if (numPots > 1) {
                    if (showdown.potIndex === 0) {
                        return 'Main Pot Showdown';
                    }
                    else {
                        return isDefault ? 'Side Pot Default Winner' : 'Side Pot Showdown';
                    }
                }
                else {
                    return isDefault ? 'Default Winner' : 'Showdown';
                }
            }
            dispatch(addTextHistoryEntry(getHeaderText(state.poker.inboundShowdowns.length, currentShowdown), 'sub'));
            currentShowdown.playerShowdownInfos.forEach((playerShowdownInfo) => {
                if (playerShowdownInfo.isShowingCards) {
                    const seatedPlayer = Object.values(state.poker.seatedPlayers).find((currSeatedPlayer) => currSeatedPlayer?.id === playerShowdownInfo.playerId);
                    if (seatedPlayer) {
                        const revealedCards = playerShowdownInfo.revealedCards.filter(isCard);
                        dispatch(addRevealedCardsHistoryEntry(revealedCards, seatedPlayer.name));
                    }
                }
            });
            if (currentShowdown.actionHtml) {
                dispatch(addHtmlHistoryEntry(currentShowdown.actionHtml));
            }
        }
        dispatch(startShowdown(showdownIndex));
        addToHistory();
        dispatch(setIsSelectingSideBetTarget(false));
        playSounds();
    };
};
export function thunkHandWinFromInbound(handWinInbound) {
    return function (dispatch) {
        dispatch(setHandWinFromInbound(handWinInbound));
        dispatch(thunkStartShowdown(0));
    };
}
export function setMyPlayerIdInPokerScene(playerId) {
    return {
        type: SET_MY_PLAYER_ID,
        payload: playerId
    };
}
function showAllInHandsFromInbound(inbound) {
    return {
        type: SHOW_ALL_IN_HANDS_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkShowAllInHandsFromInbound = (inbound) => {
    return function (dispatch, getState) {
        const state = getState();
        maybePlayRevealSound(state);
        dispatch(showAllInHandsFromInbound(inbound));
        dispatch(setIsSelectingSideBetTarget(false));
    };
};
function showAllInCommunityCardsFromInbound(inbound) {
    return {
        type: SHOW_ALL_IN_COMMUNITY_CARDS_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkShowAllInCommunityCardsFromInbound = (inbound) => {
    return function (dispatch, getState) {
        const state = getState();
        maybePlayFlopSound(state);
        dispatch(showAllInCommunityCardsFromInbound(inbound));
        dispatch(addCommunityCardsHistoryEntry(inbound.cardsWithIndexes.map((cardWithIndex) => cardWithIndex.card), inbound.newBetRound));
    };
};
export function setBetSliderAmountOnly(amount) {
    return {
        type: SET_BET_SLIDER_AMOUNT,
        payload: amount
    };
}
export function thunkSetBetSliderAmount(amount) {
    return function (dispatch, getState) {
        const betSliderMaxAmount = getState().poker.myTurnProperties?.betSliderMaxAmount;
        if (betSliderMaxAmount === undefined) {
            return;
        }
        dispatch(setBetSliderAmountOnly(Math.min(betSliderMaxAmount, amount)));
        dispatch(setBetSliderX(null));
    };
}
export function setBetSliderX(x) {
    return {
        type: SET_BET_SLIDER_X,
        payload: x
    };
}
function waitPhaseFromInbound(inbound) {
    return {
        type: WAIT_PHASE_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkWaitPhaseFromInbound(inbound) {
    return function (dispatch) {
        dispatch(waitPhaseFromInbound(inbound));
        dispatch(thunkClearSideBetsState());
    };
}
export function setBlindTimerFromInbound(inbound) {
    return {
        type: SET_BLIND_TIMER_FROM_INBOUND,
        payload: inbound
    };
}
export function updatePlayersFromInbound(updatePlayersInbound) {
    return {
        type: UPDATE_PLAYERS_FROM_INBOUND,
        payload: updatePlayersInbound
    };
}
export function addSeatedPlayerChips(seatIndex, numChipsToAdd) {
    return {
        type: ADD_SEATED_PLAYER_CHIPS,
        payload: { seatIndex, numChipsToAdd }
    };
}
export function setPokerPlayerBank(playerId, numChipsInBank) {
    return {
        type: SET_POKER_PLAYER_BANK,
        payload: { playerId, numChipsInBank }
    };
}
export function setSitOutSelfStatusFromInbound(inbound) {
    return {
        type: SET_SIT_OUT_SELF_STATUS_FROM_INBOUND,
        payload: inbound
    };
}
export function setSitOutStatusFromInbound(inbound) {
    return {
        type: SET_SIT_OUT_STATUS_FROM_INBOUND,
        payload: inbound
    };
}
export function setPokerRoomInfoFromInbound(inbound) {
    return {
        type: SET_POKER_ROOM_INFO_FROM_INBOUND,
        payload: inbound
    };
}
export function handReconnectFromInbound(inbound) {
    return {
        type: HAND_RECONNECT_FROM_INBOUND,
        payload: inbound
    };
}
export function becomePokerRoomOwner() {
    return {
        type: BECOME_OWNER
    };
}
export function updateHandRankFromInbound(inbound) {
    return {
        type: UPDATE_HAND_RANK_FROM_INBOUND,
        payload: inbound
    };
}
export function setPokerRoomStatus(status) {
    return {
        type: SET_STATUS_MESSAGE,
        payload: status
    };
}
function updatePokerRoomForClosedMtt() {
    return {
        type: UPDATE_POKER_ROOM_FOR_CLOSED_MTT
    };
}
export const thunkUpdatePokerRoomForClosedMtt = () => {
    return function (dispatch) {
        dispatch(updatePokerRoomForClosedMtt());
        dispatch(removeAllBombSplats());
    };
};
export function updatePokerRoomJacksFromInbound(inbound) {
    return {
        type: UPDATE_JACKS_FROM_INBOUND,
        payload: inbound
    };
}
export function setDiscardPhaseFromInbound(inbound) {
    return {
        type: SET_DISCARD_PHASE_FROM_INBOUND,
        payload: inbound
    };
}
export function updatePotAmountsFromInbound(inbound) {
    return {
        type: UPDATE_POT_AMOUNTS_FROM_INBOUND,
        payload: inbound
    };
}
function setSeatedPlayerAvatarFromInbound(inbound) {
    return {
        type: SET_SEATED_PLAYER_AVATAR_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkSetSeatedPlayerAvatarFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        const seatedPlayer = state.poker.seatedPlayers[inbound.seatIndex];
        if (seatedPlayer && seatedPlayer.id === state.selfData.id) {
            // avatar is changing on seated player who is also me
            dispatch(setSelfAvatar(maybeOverrideAvatar(seatedPlayer.id, seatedPlayer.name, inbound.avatar) || inbound.avatar));
        }
        dispatch(setSeatedPlayerAvatarFromInbound(inbound));
    };
}
export function updatePlayersMedalsAndStyleFromInbound(inbound) {
    return {
        type: UPDATE_PLAYERS_MEDALS_AND_STYLE_FROM_INBOUND,
        payload: inbound
    };
}
export function setIsAutoChecking(isAutoChecking) {
    return {
        type: SET_IS_AUTO_CHECKING,
        payload: isAutoChecking
    };
}
export function setIsAutoFoldingAny(isAutoFoldingAny) {
    return {
        type: SET_IS_AUTO_FOLDING_ANY,
        payload: isAutoFoldingAny
    };
}
export function setHandRevealingFromInbound(inbound) {
    return {
        type: SET_HAND_REVEALING_FROM_INBOUND,
        payload: inbound
    };
}
function setRequestedBuyIn(payload) {
    return {
        type: SET_REQUESTED_BUY_IN,
        payload
    };
}
export function thunkSetRequestedBuyIn(requestedBuyIn, rememberRequestedBuyIn, socketSend) {
    return function (dispatch) {
        dispatch(setRequestedBuyIn({ requestedBuyIn, rememberRequestedBuyIn }));
        socketSend(createSetBuyInOutbound(requestedBuyIn));
    };
}
export function thunkSitDown(seatIndex, requestedBuyIn, rememberRequestedBuyIn, socketSend) {
    return function (dispatch, getState) {
        const state = getState();
        const isAllInGame = state.poker.isAllInGame;
        if (!validateSupportedPokerVariantIdOrShowError(isAllInGame, dispatch)) {
            return;
        }
        if (requestedBuyIn === undefined) {
            socketSend(createSitOutbound(seatIndex));
        }
        else {
            dispatch(setRequestedBuyIn({ requestedBuyIn, rememberRequestedBuyIn }));
            const validRequestedBuyIn = getState().poker.requestedBuyIn;
            if (validRequestedBuyIn) {
                socketSend(createSitWithBuyInOutbound(seatIndex, validRequestedBuyIn));
            }
        }
    };
}
export function setDiscardCardIndex(cardIndex) {
    return {
        type: SET_DISCARD_CARD_INDEX,
        payload: cardIndex
    };
}
export function setHoleCardsAfterDiscardFromInbound(inbound) {
    return {
        type: SET_HOLE_CARDS_AFTER_DISCARD_FROM_INBOUND,
        payload: inbound
    };
}
export function setDiscardPhaseDoneFromInbound(inbound) {
    return {
        type: SET_DISCARD_PHASE_DONE_FROM_INBOUND,
        payload: inbound
    };
}
export function setPendingDiscardIndex(cardIndex) {
    return {
        type: SET_PENDING_DISCARD_INDEX,
        payload: cardIndex
    };
}
export function setPlayerHadDiscardedFromInbound(inbound) {
    return {
        type: SET_PLAYER_HAS_DISCARDED_FROM_INBOUND,
        payload: inbound
    };
}
export function updateLastChipStackFromInbound(inbound) {
    return {
        type: UPDATE_LAST_CHIP_STACK_FROM_INBOUND,
        payload: inbound
    };
}
function showBlankChatBubbleFromInbound(inbound) {
    return {
        type: SHOW_BLANK_CHAT_BUBBLE_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkShowBlankChatBubbleFromInbound(inbound) {
    return function (dispatch) {
        dispatch(showBlankChatBubbleFromInbound(inbound));
        dispatch(addPlayerAnimation(inbound.seatIndex, {
            type: 'chat-action',
            totalY: -5,
            durationMs: Math.max(300, MINIMUM_PLAYER_ANIMATION_DURATION_MS)
        }));
    };
}
export function hideChatBubble(seatIndex) {
    return {
        type: HIDE_CHAT_BUBBLE,
        payload: seatIndex
    };
}
export function hideDealingMessage() {
    return { type: HIDE_DEALING_MESSAGE };
}
export function renamePokerRoom(newName) {
    return { type: RENAME_POKER_ROOM, payload: newName };
}
export function showPokerRoomPrizeWinFromInbound(inbound) {
    return { type: SHOW_POKER_ROOM_PRIZE_WIN_FROM_INBOUND, payload: inbound };
}
export function hidePokerRoomPrizeWin() {
    return { type: HIDE_POKER_ROOM_PRIZE_WIN };
}
export function updateChipStacksFromInbound(inbound) {
    return { type: UPDATE_CHIP_STACKS_FROM_INBOUND, payload: inbound };
}
export function startWinChipsAnimation(seatIndex) {
    return { type: START_WIN_CHIPS_ANIMATION, payload: seatIndex };
}
export function clearWinChipsAnimation(seatIndex) {
    return { type: CLEAR_WIN_CHIPS_ANIMATION, payload: seatIndex };
}
function setSideBetPhaseFromInbound(inbound) {
    return {
        type: SET_SIDE_BET_PHASE_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkSetSideBetPhaseFromInbound(inbound) {
    return function (dispatch) {
        dispatch(setSideBetPhaseFromInbound(inbound));
        if (inbound.disableSideBetsInterface) {
            dispatch(disableMySideBetControls());
        }
    };
}
